export default __webpack_public_path__ + "static/media/ic-check-outlined.26ab5d95.svg";